module.exports = __webpack_public_path__ + "img/Pack Station (WMS Module)_Page_07.cc8c70dc.jpg";